module.exports = __webpack_public_path__ + "static/media/api.63f68ccc.svg";